// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentMethodView-Skeleton_cls1__4Cs51","cls2":"PaymentMethodView-Skeleton_cls2__5KL0h PaymentMethodView-Skeleton_cls1__4Cs51"};